"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICE_TYPE_RRP = exports.PRICE_TYPE_EM = exports.PRICE_TYPE_STD = exports.PRICE_TYPE_SELL = exports.PRICE_STATE_RRP = exports.PRICE_STATE_WAS = exports.PRICE_STATE_NOW = exports.PRICE_STATE_NOW_FROM = exports.PRICE_STATE_FROM = void 0;
exports.PRICE_STATE_FROM = 'FROM';
exports.PRICE_STATE_NOW_FROM = 'NOW_FROM';
exports.PRICE_STATE_NOW = 'NOW';
exports.PRICE_STATE_WAS = 'WAS';
exports.PRICE_STATE_RRP = 'RRP';
exports.PRICE_TYPE_SELL = 'SELL';
exports.PRICE_TYPE_STD = 'STD';
exports.PRICE_TYPE_EM = 'EM';
exports.PRICE_TYPE_RRP = 'RRP';
//# sourceMappingURL=PriceEnums.js.map